export default __webpack_public_path__ + "static/media/eyeballs.4c1adade.svg";